import React from 'react';
import styled from 'styled-components';

/*

Props:

*/

const StyledForm = styled.input`
  display: flex;
  flex: 1;
  outline-width: 0;
  min-width: 200px;
`;

const TextInputSC = ({ styles, ...rest }) => (
  <StyledForm style={styles} {...rest} />
)

export default TextInputSC

// flex-direction: ${props => props.flexDirection ? props.flexDirection : 'row'};



// WEBPACK FOOTER //
// ./src/js/components/Chat/TextInputSC.jsx